import { Stack, Typography } from '@mui/material';
import { BackButton } from '../Button/BackButton/BackButton';

type Position = 'center' | 'left';

interface TitleWithBackButtonProps {
  title: string;
  position?: Position;
}

export const TitleWithBackButton = ({
  title,
  position = 'left',
}: TitleWithBackButtonProps) => {
  return (
    <Stack
      direction="row"
      justifyContent="flex-start"
      alignItems="center"
      sx={{ position: 'relative', width: '100%' }}
    >
      <BackButton skipReloadPage />
      <Typography
        variant="h2"
        color="common.white"
        textAlign={position === 'center' ? 'center' : 'left'}
        sx={{
          ...(position === 'center' && {
            position: 'absolute',
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 1,
          }),
          ...(position === 'left' && {
            marginLeft: 'auto',
          }),
          width: '100%',
          maxWidth: 'max-content',
        }}
      >
        {title}
      </Typography>
    </Stack>
  );
};
